module.exports = __webpack_public_path__ + "assets/images/slope-education/mobile.svg?v=4fd19e84";